module.exports = require("@wildboar/x500/src/lib/modules/DirectoryAbstractService/ListResult.ta");